import { useMutation } from '@apollo/client';
import {
  UpdateDefaultCheckoutDotComCardMutation,
  UpdateDefaultCheckoutDotComCardMutationVariables,
} from '__generated__/graphql';
import { UPDATE_DEFAULT_CHECKOUT_DOT_COM_CARD } from '../graphql/updateDefaultCheckoutDotComCard';

export function useUpdateDefaultCheckoutDotComCard() {
  const [updateDefaultCard, { loading: processingDefaultCardRequest }] = useMutation<
    UpdateDefaultCheckoutDotComCardMutation,
    UpdateDefaultCheckoutDotComCardMutationVariables
  >(UPDATE_DEFAULT_CHECKOUT_DOT_COM_CARD, {
    onError: () => null,
  });

  return { updateDefaultCard, processingDefaultCardRequest };
}
